import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Tag } from 'antd';
import { CustomerServiceOutlined, PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import CreateTicketModal from './CreateTicketModal';
import { getSupportTickets, TICKET_STATUS_COLORS } from '../modules/support-tickets/api';

/**
 * OVO-117 — the order page's support tie-in (ADMIN/USER only; the parent hides
 * it for partner viewers). Lists the order's tickets as clickable chips and
 * offers "Create ticket" prefilled with the order (the backend derives
 * partner/route/driver from it).
 */
export default function OrderTicketsPanel({ order }) {
  const { t } = useTranslation(['routes', 'common']);
  const [tickets, setTickets] = useState([]);
  const [createOpen, setCreateOpen] = useState(false);

  const load = useCallback(() => {
    if (!order?.orderCode) return;
    getSupportTickets({ orderCode: order.orderCode, take: 20 })
      .then(({ response }) => setTickets(response?.items || []))
      .catch(() => {});
  }, [order?.orderCode]);

  useEffect(() => {
    load();
  }, [load]);

  if (!order?.id) return null;

  return (
    <div className="white" style={{ padding: 12, marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
        <b>
          <CustomerServiceOutlined style={{ marginRight: 6 }} />
          {t('tickets.ticketsForOrder', { count: tickets.length })}
        </b>
        <Button size="small" icon={<PlusOutlined />} onClick={() => setCreateOpen(true)}>
          {t('tickets.createFromHere')}
        </Button>
      </div>
      {tickets.length > 0 && (
        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {tickets.map((tk) => (
            <div key={tk.id} style={{ fontSize: 13 }}>
              <Link to={`/admin/tickets/${tk.id}`}>#{tk.id}</Link>{' '}
              <Tag color={TICKET_STATUS_COLORS[tk.status]} style={{ marginLeft: 4 }}>
                {t(`tickets.statuses.${tk.status}`, tk.status)}
              </Tag>
              {tk.subject}
            </div>
          ))}
        </div>
      )}
      <CreateTicketModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={load}
        prefill={{ orderId: order.id, orderCode: order.orderCode, partnerId: order.partnerId }}
      />
    </div>
  );
}
